export default "__VITE_ASSET__By3UG6XH__"